import BasePopup from '../Base/BasePopup';

export default BasePopup;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-tree-select/src/Popup/MultiplePopup.js
// module id = 899
// module chunks = 0